import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<IVisaPrepForm, 'qualificationAndCountry' | 'qualificationAsProofOfEnglish'>;

type Params = Fields;

export function getPageStatus({ qualificationAndCountry, qualificationAsProofOfEnglish }: Params): {
  complete: boolean;
} {
  let complete = false;
  if (
    qualificationAsProofOfEnglish === undefined ||
    (qualificationAsProofOfEnglish === true &&
      (qualificationAndCountry === undefined || qualificationAndCountry === ''))
  ) {
    complete = false;
  } else {
    complete = true;
  }

  return { complete };
}
